<p-toast></p-toast>
<p-dialog [(visible)]="display" [style]="{width: '50vw'}" [modal]="true" [draggable]="false" [resizable]="false"
    (onHide)="close()" styleClass="inr-dialog">
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
            <span class="dialog-icon-container">
                <i class="pi pi-user-plus" style="color: white; font-size: 1.2rem;"></i>
            </span>
            <span class="font-bold text-xl ml-2 text-900">New Patient Information</span>
        </div>
    </ng-template>

    <form [formGroup]="form" class="grid p-fluid mt-2">
        <!-- MRN -->
        <div class="col-12 field">
            <label for="mrn" class="font-medium text-color-secondary text-sm">MRN</label>
            <input pInputText id="mrn" formControlName="mrn" placeholder="Enter MRN"
                [ngClass]="{'ng-invalid ng-dirty': form.get('mrn')?.invalid && form.get('mrn')?.touched}" />
            <small class="p-error" *ngIf="form.get('mrn')?.invalid && form.get('mrn')?.touched">
                MRN is required
            </small>
        </div>

        <!-- Initial Dose & Blood Type -->
        <div class="col-12 md:col-6 field">
            <label for="initialDose" class="font-medium text-color-secondary text-sm">Initial Marevan Dose</label>
            <input pInputText id="initialDose" formControlName="initialMarevanDose" type="number" min="0"
                placeholder="Enter dose amount" class="w-full"
                [ngClass]="{'ng-invalid ng-dirty': form.get('initialMarevanDose')?.invalid && form.get('initialMarevanDose')?.touched}" />
            <small class="p-error"
                *ngIf="form.get('initialMarevanDose')?.invalid && form.get('initialMarevanDose')?.touched">
                <span *ngIf="form.get('initialMarevanDose')?.errors?.['required']">Dose is required</span>
                <span *ngIf="form.get('initialMarevanDose')?.errors?.['min']">Dose must be at least 0</span>
                <span *ngIf="form.get('initialMarevanDose')?.errors?.['max']">Dose cannot exceed 20</span>
            </small>
        </div>
        <div class="col-12 md:col-6 field">
            <label for="bloodType" class="font-medium text-color-secondary text-sm">Blood Type</label>
            <p-dropdown id="bloodType" [options]="bloodTypes" formControlName="bloodType"
                placeholder="Select Blood Type" [showClear]="true"></p-dropdown>
        </div>

        <!-- Target INR -->
        <div class="col-12 md:col-6 field">
            <label for="targetInrFrom" class="font-medium text-color-secondary text-sm">Target INR From</label>
            <input pInputText id="targetInrFrom" formControlName="targetInrFrom" type="number" min="0" step="0.1"
                placeholder="Enter target INR from" class="w-full"
                [ngClass]="{'ng-invalid ng-dirty': form.get('targetInrFrom')?.invalid && form.get('targetInrFrom')?.touched}" />
            <small class="p-error" *ngIf="form.get('targetInrFrom')?.invalid && form.get('targetInrFrom')?.touched">
                <span *ngIf="form.get('targetInrFrom')?.errors?.['required']">Target INR From is required</span>
                <span *ngIf="form.get('targetInrFrom')?.errors?.['min']">Value must be at least 1</span>
                <span *ngIf="form.get('targetInrFrom')?.errors?.['max']">Value cannot exceed 20</span>
            </small>
        </div>
        <div class="col-12 md:col-6 field">
            <label for="targetInrTo" class="font-medium text-color-secondary text-sm">Target INR To</label>
            <input pInputText id="targetInrTo" formControlName="targetInrTo" type="number" min="0" step="0.1"
                placeholder="Enter target INR to" class="w-full"
                [ngClass]="{'ng-invalid ng-dirty': form.get('targetInrTo')?.invalid && form.get('targetInrTo')?.touched}" />
            <small class="p-error" *ngIf="form.get('targetInrTo')?.invalid && form.get('targetInrTo')?.touched">
                <span *ngIf="form.get('targetInrTo')?.errors?.['required']">Target INR To is required</span>
                <span *ngIf="form.get('targetInrTo')?.errors?.['min']">Value must be at least 1</span>
                <span *ngIf="form.get('targetInrTo')?.errors?.['max']">Value cannot exceed 20</span>
            </small>
        </div>

        <!-- Dates -->
        <div class="col-12 md:col-6 field">
            <label class="font-medium text-color-secondary text-sm">Start Monitoring Date</label>
            <p-calendar formControlName="startMonitoringDate" placeholder="DD / MM / YYYY" dateFormat="dd/mm/yy"
                [showIcon]="false" styleClass="w-full" [minDate]="minDate"
                [ngClass]="{'ng-invalid ng-dirty': form.get('startMonitoringDate')?.invalid && form.get('startMonitoringDate')?.touched}"></p-calendar>
            <small class="p-error"
                *ngIf="form.get('startMonitoringDate')?.invalid && form.get('startMonitoringDate')?.touched">
                Start Monitoring Date is required
            </small>
        </div>
        <div class="col-12 md:col-6 field">
            <label class="font-medium text-color-secondary text-sm">Next Test Date</label>
            <p-calendar formControlName="nextTestDate" placeholder="DD / MM / YYYY" dateFormat="dd/mm/yy"
                [showIcon]="false" styleClass="w-full" [minDate]="minNextTestDate"
                [ngClass]="{'ng-invalid ng-dirty': form.get('nextTestDate')?.invalid && form.get('nextTestDate')?.touched}"></p-calendar>
            <small class="p-error" *ngIf="form.get('nextTestDate')?.invalid && form.get('nextTestDate')?.touched">
                Next Test Date is required
            </small>
        </div>

        <!-- Notes -->
        <!-- <div class="col-12 field">
            <label for="internalNotes" class="font-medium text-color-secondary text-sm font-bold text-900">Internal
                Notes</label>
            <textarea pInputTextarea id="internalNotes" formControlName="internalNotes" class="w-full response-note"
                placeholder="Write your note here..." dir="auto"></textarea>
        </div> -->
    </form>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <button pButton label="Cancel" class="btn-secondary" (click)="close()"></button>
            <button pButton label="Assign" class="btn-primary" (click)="save()" [disabled]="form.invalid"
                [loading]="loading"></button>
        </div>
    </ng-template>
</p-dialog>